import React, { useState } from "react";
import data from "../data";
import {
  ShieldCheckIcon,
  HandThumbUpIcon,
  CogIcon,
} from "@heroicons/react/24/solid";
import VideoModal from "../components/VideoModal";

const About = () => {
  const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <div className="container mx-auto px-6 py-12 sm:px-8 md:px-12 lg:px-16 xl:px-60">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row items-center gap-12 mb-12">
        {/* Text Section */}
        <div className="md:w-1/2 order-2 md:order-1">
          <h1 className="text-5xl font-bold text-primary mb-6">
            {data.about.title}
          </h1>
          <p className="text-lg text-gray-700 mt-4">{data.about.story1}</p>
          <p className="text-lg text-gray-700 mt-4">{data.about.story2}</p>
          {/* "Will It Print?" with Clickable Video Modal */}
          <p className="text-lg text-gray-700 mt-4">
            The wallPen’s precision and quality blew us away, and we knew we had
            something special. We even launched a YouTube channel,{" "}
            <button
              className="text-primary underline hover:text-secondary"
              onClick={() => setVideoModalOpen(true)}
            >
              Will It Print?
            </button>
            , to see just how far we could push the technology. From surfboards
            to window blinds, if it could stand upright, we printed on it. Now,
            we’re bringing this game-changing tech to businesses and creatives
            everywhere.
          </p>
        </div>

        {/* Image Section */}
        <div className="md:w-1/2 order-1 md:order-2 flex justify-center">
          <img
            src={data.about.aboutImage}
            alt="SurfacePix Team"
            className="rounded-lg shadow-lg w-full max-w-[450px] h-[600px] object-cover"
          />
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gray-100 p-12 rounded-lg shadow-lg text-center">
        <h2 className="text-4xl font-bold text-primary mb-4">Why Choose Us</h2>
        <h3 className="text-2xl font-bold text-gray-800 mb-4">
          3 Years of Experience
        </h3>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-12">
          We’ve run a successful business using the wallPen to print murals,
          art, and graphics on the walls of businesses and homeowners all over
          the state of Utah.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {/* Trust */}
          <div className="p-6 border rounded-lg shadow-lg bg-white flex flex-col items-center">
            <ShieldCheckIcon className="text-secondary w-12 h-12 mb-4" />
            <h3 className="text-xl font-semibold text-primary">Trust</h3>
            <p className="text-gray-600 mt-2">
              Working alongside our partners has brought us tremendous amounts
              of joy and fulfillment. We are proud to be a partner that you can
              count on.
            </p>
          </div>
          {/* Quality */}
          <div className="p-6 border rounded-lg shadow-lg bg-white flex flex-col items-center">
            <HandThumbUpIcon className="text-secondary w-12 h-12 mb-4" />
            <h3 className="text-xl font-semibold text-primary">Quality</h3>
            <p className="text-gray-600 mt-2">
              The wallPen is technology that you can feel confident using to
              attract customers and grow your portfolio. There hasn’t been a
              better invention in the world of vertical printing.
            </p>
          </div>
          {/* Opportunity */}
          <div className="p-6 border rounded-lg shadow-lg bg-white flex flex-col items-center">
            <CogIcon className="text-secondary w-12 h-12 mb-4" />
            <h3 className="text-xl font-semibold text-primary">Opportunity</h3>
            <p className="text-gray-600 mt-2">
              As a certified reseller of wallPen, the manufacturer has entrusted
              us to sell their machines across America. Become the first
              certified SurfacePix partner in your city.
            </p>
          </div>
        </div>
      </div>

      {/* Meet Our Team Section */}
      <div className="mt-16">
        <h2 className="text-4xl font-bold text-center text-primary mb-8">
          Meet Our Team
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {data.about.team.map((member, index) => (
            <div
              key={index}
              className="bg-white p-6 border rounded-lg shadow-lg flex flex-col items-center"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-40 h-40 rounded-full object-cover shadow-lg"
              />
              <h3 className="text-xl font-semibold text-primary mt-4">
                {member.name}
              </h3>
              <p className="text-gray-600">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Video Modal */}
      <VideoModal
        videoUrl={data.about.videoUrl}
        isOpen={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
      />
    </div>
  );
};

export default About;
